/**
 * Which AnyAPI account the dashboard is acting for. One Clerk person can act for
 * their own account or, with an active Clerk organization, for a Team, so the
 * person alone does not say whose data is on screen.
 */
export interface AuthenticatedAccount {
  readonly userId: string;
  /** The active Clerk organization, or null on the person's own account. */
  readonly orgId: string | null;
}

/** The cache and lifetime key: distinct for every person and account pair. */
export const accountSubject = ({ userId, orgId }: AuthenticatedAccount): string =>
  orgId ? `${userId}:${orgId}` : userId;
